/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/prop-types */
/*
 * IMPORT
 */
import React, { useState, useEffect } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { connect } from "react-redux"; // NPM: React-redux library.
import { MdOutlineFileUpload } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import _ from "underscore";
import { videoBigTextStyle, videoBigTextStyle1 } from "../../../../components/Styles/index.style"

/*
 * CHAKRA IMPORTS
 */
import {
  Image,
  Flex,
  Text,
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Input,
  InputGroup,
  useToast,
  Spinner,
  FormControl,
  FormLabel,
  Link,
  useDisclosure,
} from "@chakra-ui/react";

/*
 * QUERY
 */

import HomePageMovieRead from "../__query__/index.homeMovieFetch.query";

/*
 * MUTATAION
 */

import HomePageMovieCreate from "../__mutation__/index.homeMovieUpload.mutation";

import HomePageMovieDelete from "../__mutation__/index.homePageMovieDelete.mutation";

function Index({ account }) {
  /*
   * States
   */

  const toast = useToast();
  const [movieUrl, setMovieUrl] = useState("");
  const [movieList, setMovieList] = useState();
  const [posterMovie, setPosterMovie] = useState();
  const [posterMovieVertical, setPosterMovieVertical] = useState();
  const [posterDeleteId, setPosterDeleteId] = useState();

  const {
    isOpen: isModalOpen,
    onOpen: openModal,
    onClose: closeModal,
  } = useDisclosure();

  const [HomePageMovieDeleteMutation, { loading: loadingHomePageMovieDelete }] =
    useMutation(HomePageMovieDelete, {
      context: {
        headers: {
          "l-authorization": account.token,
        },
      },
    });

  const [HomePageMovieCreateMutation, { loading: loadingHomeMovieUpload }] =
    useMutation(HomePageMovieCreate, {
      context: {
        headers: {
          "l-authorization": account.token,
        },
      },
    });

  const { refetch: HomePageMovieReadRefetch, data: HomePageMovieReadQuery } =
    useQuery(HomePageMovieRead, {
      context: {
        headers: {
          "l-authorization": account.token,
        },
      },
    });

  /*
   * STYLE
   */
 

 
  /*
   * Functions
   */
  const handleMovieUrl = (e) => {
    setMovieUrl(e.target.value);
  };

  const handleMovieImageUpload = (e) => {
    const file = e.target.files[0];

    // Check if a file is selected
    if (file) {
      const generatedUniqueId = uuidv4();

      setPosterMovie({
        ...posterMovie,
        thumbnailStoredAt: file,
        uniqueId: generatedUniqueId,
      });
    }
  };

  const handleVerticalMovieImageUpload = (e) => {
    const file = e.target.files[0];

    // Check if a file is selected
    if (file) {
      const generatedUniqueId = uuidv4();

      setPosterMovieVertical({
        ...posterMovieVertical,
        thumbnailStoredAt: file,
        uniqueId: generatedUniqueId,
      });
    }
  };

  const handleHomeMovieUpload = async () => {
    try {
      const response = await HomePageMovieCreateMutation({
        variables: {
          moviePoster: posterMovie,
          movieUrl: movieUrl,
          verticalPoster: posterMovieVertical,
        },
      });

      const data = response.data.HomePageMovieCreate;

      if (!_.isEmpty(data)) {
        toast({
          title: "Form Submitted",
          description: "Data saved successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setMovieUrl("");
        setPosterMovie("");
        setPosterMovieVertical("");
      }
    } catch (error) {
      // Show error toast
      toast({
        title: "Error",
        description: "An error occurred Pls Try Again Later.",
        status: "error",
        duration: 5000, // Milliseconds
        isClosable: true,
      });
    }
  };

  const handleMovieDelete = async () => {
    try {
      const response = await HomePageMovieDeleteMutation({
        variables: {
          homePageMovieId: posterDeleteId,
        },
      });

      const data = response.data.HomePageMovieDelete;

      if (!_.isEmpty(data)) {
        toast({
          title: "Successfully deleted",
          description: "Data saved successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        closeModal(); // Close the modal after successful deletion
      }
    } catch (error) {
      // Show error toast
      toast({
        title: "Error",
        description: "An error occurred Pls Try Again Later.",
        status: "error",
        duration: 5000, // Milliseconds
        isClosable: true,
      });
    }
  };

  const handleRemoveClick = (id) => {
    setPosterDeleteId(id);
    openModal(); // Open the modal
  };

  async function HandleHomePageMovieReadRefetch() {
    await HomePageMovieReadRefetch();
  }

  useEffect(() => {
    HandleHomePageMovieReadRefetch();
  }, [loadingHomeMovieUpload, loadingHomePageMovieDelete]);

  useEffect(() => {
    if (HomePageMovieReadQuery && HomePageMovieReadQuery.HomePageMovieRead) {
      setMovieList(HomePageMovieReadQuery?.HomePageMovieRead);
    }
  }, [HomePageMovieReadQuery]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleHomeMovieUpload();
  };

  return (
    <Flex direction="column" pt="50px" pb="50px" align="center">
      <Flex direction="column">
        <form style={{ width: "100%" }} onSubmit={handleSubmit}>
          <Flex align="end" p="20px" w="100%">
            <FormControl>
              <FormLabel style={videoBigTextStyle}>
                Upload Horizontal Movie Poster
              </FormLabel>
              <InputGroup align="center">
                <Button
                  style={videoBigTextStyle1}
                  border="1px solid #3D445A"
                  bg="transparent"
                  _hover={{ bg: "transparent" }}
                  onClick={() => {
                    // Trigger the hidden file input when the button is clicked
                    document.getElementById("thumbnailMovieInput").click();
                  }}
                  width={{ base: "320px" }}
                  position="relative"
                >
                  <MdOutlineFileUpload
                    size="25px"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  />
                </Button>
                {/* Hidden file input */}
                <Input
                  type="file"
                  id="thumbnailMovieInput"
                  name="thumbnailStoredAt"
                  onChange={handleMovieImageUpload}
                  display="none"
                />
              </InputGroup>
            </FormControl>
            <FormControl>
              <FormLabel style={videoBigTextStyle}>
                Upload Vertical Movie Poster
              </FormLabel>
              <InputGroup align="center">
                <Button
                  style={videoBigTextStyle1}
                  border="1px solid #3D445A"
                  bg="transparent"
                  _hover={{ bg: "transparent" }}
                  onClick={() => {
                    // Trigger the hidden file input when the button is clicked
                    document
                      .getElementById("thumbnailVerticalMovieInput")
                      .click();
                  }}
                  width={{ base: "320px" }}
                  position="relative"
                >
                  <MdOutlineFileUpload
                    size="25px"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  />
                </Button>
                {/* Hidden file input */}
                <Input
                  type="file"
                  id="thumbnailVerticalMovieInput"
                  name="thumbnailStoredAt"
                  onChange={handleVerticalMovieImageUpload}
                  display="none"
                />
              </InputGroup>
            </FormControl>
            <FormControl>
              <FormLabel style={videoBigTextStyle}>Movie Url</FormLabel>
              <InputGroup>
                <Input
                  width="320px"
                  borderColor="rgba(116, 116, 116, 1)"
                  color="white"
                  placeholder="Url"
                  value={movieUrl}
                  onChange={handleMovieUrl}
                />
              </InputGroup>
            </FormControl>

            <Button
              bg="blue.600"
              color="white"
              w="210px"
              h="50px"
              _hover={{ bg: "blue.500" }}
              type="submit"
            >
              {loadingHomeMovieUpload ? <Spinner /> : "Save"}
            </Button>
          </Flex>
        </form>
        <Flex
          gap="20px"
          align="center"
          borderRadius="10px"
          border="1px solid #878992"
          p="20px"
        >
          <Flex>
            {posterMovie ? (
              <Image
                src={
                  !!posterMovie?.thumbnailStoredAt
                    ? URL.createObjectURL(posterMovie?.thumbnailStoredAt)
                    : ""
                }
              />
            ) : (
              <Text style={videoBigTextStyle}>No poster</Text>
            )}
          </Flex>
          <Flex>
            {posterMovieVertical ? (
              <Image
                src={
                  !!posterMovieVertical?.thumbnailStoredAt
                    ? URL.createObjectURL(
                        posterMovieVertical?.thumbnailStoredAt
                      )
                    : ""
                }
              />
            ) : (
              <Text style={videoBigTextStyle}>No poster</Text>
            )}
          </Flex>
          <Link style={videoBigTextStyle} href={movieUrl} target="_blank">
            {movieUrl || "No url provided"}
          </Link>
        </Flex>
      </Flex>

      <Flex
        overflowY="auto"
        maxHeight="700px"
        p="35px 24px"
        direction="column"
        gap="3rem"
      >
        {movieList?.map((data, index) => (
          <Flex
            key={data.id}
            p="15px"
            borderRadius="10px"
            bg="#000000"
            w="100%"
            gap="1rem"
            cursor="pointer"
            direction="column"
            align="center"
          >
            <Flex
              bg="white"
              w="40px"
              h="40px"
              borderRadius="50%"
              textAlign="center"
              color="white"
              justify="center"
              align="center"
            >
              <Text fontWeight="600" fontSize="20px" color="black">
                {index + 1}
              </Text>
            </Flex>
            <Flex direction="column">
              <Text style={videoBigTextStyle1}>Brand poster :</Text>
              <Image src={data?.moviePoster} />
            </Flex>
            <Flex direction="column">
              <Text style={videoBigTextStyle1}>Brand Vertical poster :</Text>
              <Image src={data?.verticalMoviePoster} />
            </Flex>
            <Flex mt="1rem" w="100%" direction="column">
              <Text style={videoBigTextStyle1}>Brand url :</Text>
              <Link
                href={data?.movieUrl}
                target="_blank"
                color="blue.600"
                style={videoBigTextStyle}
              >
                {data?.movieUrl}
              </Link>
            </Flex>

            <Button
              colorScheme="red"
              onClick={() => handleRemoveClick(data?.id)}
            >
              Remove
            </Button>
            {/* Remove Modal */}
            <Modal isOpen={isModalOpen} onClose={closeModal} isCentered>
              <ModalContent>
                <ModalHeader>Confirm Removal</ModalHeader>
                <ModalBody>
                  Are you sure you want to remove this poster from our platform?
                </ModalBody>
                <ModalFooter gap="20px">
                  <Button colorScheme="red" onClick={handleMovieDelete}>
                    {loadingHomePageMovieDelete ? <Spinner /> : "Yes"}
                  </Button>
                  <Button onClick={closeModal}>No</Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}

const _MapDispatchToProps = (__dispatch) => ({
  AccountUpdate: (u) => __dispatch({ type: "ACCOUNT_UPDATE", Account: u }),
  AccountLogout: () => __dispatch({ type: "ACCOUNT_CLEAR" }),
});

const _MapStateToProps = (state) => ({
  account: state.Account,
});

/*
 * EXPORTS
 */
export default connect(_MapStateToProps, _MapDispatchToProps)(Index);
